import React from "react";
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AgruparByProp } from "../../../../Helpers/Agrupaciones/AgruparByProp";
import request from "../../../../Helpers/API";
import { GetMonthNameByNumber } from "../../Helper/GetMonthNameByNumber";
// import { useBoxFiltros, useLoading } from "../../../hooks/useForm";
import { useBoxFiltros, useBox } from "../../Helper/useBox";
import { BoxFiltros } from "../../Helper/BoxFiltros";
// import { formatMoney } from "../../components/FormatMoney";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { LoaderScreen } from '../../../components/LoaderScreen';
// import { Loading } from "../../components/LoadinScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { BoxFiltros2 } from "../../Helper/BoxFiltros2";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FiltroCostoFinanciamiento } from "../../Helper/FiltroCostoFinanciamiento";
const fechaActual = new Date();
const ejercicioActual = fechaActual.getFullYear();
const mesActual = fechaActual.getMonth() + 1;

const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};

const initialStateboxfiltros = {
    ejercicioinicio: storedState.ejercicio || ejercicioActual,
    periodoinicio: storedState.periodoinicio || "1",
    ejerciciofin: storedState.ejercicio || ejercicioActual,
    periodofin: storedState.periodofin || mesActual,
    pv: { adr: [], sucursal: [], departamento: [] },
    visualizacion: "1"
};
export const CostoFinanciamientoScreen = () => {
    const [boxstate, setBoxState] = useBox(initialStateboxfiltros);
    const location = useLocation();
    const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};
    const permisos = location.state;
    const [titulo, setTitulo] = useState('COSTO DE FINANCIAMIENTO');
    const history = useHistory();
    const onHome = () => {
        history.push("/Finanzas/Main")
    };

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [state, setState] = useState({
        subtitulo: "",
        data: [],
        tituloactua: "",
        tituloanterior: "",
        gastosfinancieros: 0,
        productofinanciero: 0,
        otrosgastosyproductos: 0,
    });

    // console.log(boxstate)

    useEffect(() => {
        boxstate.ejercicioinicio = storedState.ejercicio;
        boxstate.periodoinicio = storedState.periodoinicio;
        boxstate.ejerciciofin = storedState.ejercicio;
        boxstate.periodofin = storedState.periodofin;
        handdleBoxClick();
    }, []);

    const handdleBoxClick = () => {
        return new Promise((res, req) => {
            if (boxstate.ejercicioinicio === "0") {
                req("Favor de agregar el ejercicio de inicio");
                return;
            }
            if (boxstate.periodoinicio === "0") {
                req("Favor de agregar el periodo de inicio");
                return;
            }
            if (boxstate.ejerciciofin === "0") {
                req("Favor de agregar el ejercicio fin");
                return;
            } else if (
                Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)
            ) {
                req("El ejercicio de inicio debe ser menor o igual al ejercicio final");
                return;
            }
            if (boxstate.periodofin === "0") {
                req("Favor de indicar el periodo final");
                return;
            } else if (
                Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
                Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
            ) {
                req("El periodo de inicio no puede ser mayor a l periodo fin");
                return;
            }

            const fechainicio = new Date(
                boxstate.ejercicioinicio,
                Number(boxstate.periodoinicio) - 1,
                "01"
            );
            const fechafin = new Date(
                boxstate.ejerciciofin,
                Number(boxstate.periodofin) - 1,
                "01"
            );
            const post = {
                fechainicio,
                fechafin,
            };

            setLoader({ ...loader, mostrar: true });

            request
                .post("FECostoFinanciamiento/Obtener", post)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    var grupos = AgruparByProp(result, "grupo");
                    if (grupos !== undefined && grupos !== null && grupos.length > 0) {
                        var arreglos = [];
                        grupos.forEach((gpo) => {
                            var arraygrupo = result.filter(
                                (x) => x.grupo === gpo && x.concepto !== "TOTAL"
                            );
                            var element = {
                                grupo: gpo,
                                data: arraygrupo,
                                real: result.filter(
                                    (x) => x.grupo === gpo && x.concepto === "TOTAL"
                                )[0].real,
                                anterior: result.filter(
                                    (x) => x.grupo === gpo && x.concepto === "TOTAL"
                                )[0].anterior,
                            };
                            arreglos = [...arreglos, element];
                        });
                        // console.log(arreglos);
                        setState({
                            ...state,
                            data: arreglos,
                            tituloactua: GetFechaActual(),
                            tituloanterior: GetFechaActualAnterior(),
                        });
                    }
                    if (
                        String(boxstate.periodoinicio) === String(boxstate.periodofin) &&
                        String(boxstate.ejercicioinicio) === String(boxstate.ejerciciofin)
                    ) {
                        setTitulo(
                            `COSTO DE FINANCIAMIENTO ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} ${boxstate.ejercicioinicio}`
                        );
                    } else {
                        setTitulo(
                            `COSTO DE FINANCIAMIENTO ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} ${boxstate.ejercicioinicio} - ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} ${boxstate.ejerciciofin}`
                        );
                    }

                    res("");
                })
                .catch((err) => {
                    setLoader({ ...loader, mostrar: false });
                    req(JSON.stringify(err));
                });
        });
    };

    const GenerarExcel = () => {
        // stratloading(true);
        //   if (boxstate.ejercicioinicio === "0") {
        //     changeloading("Favor de agregar el ejercicio de inicio", true);
        //     return;
        //   }
        //   if (boxstate.periodoinicio === "0") {
        //     changeloading("Favor de agregar el periodo de inicio", true);
        //     return;
        //   }
        //   if (boxstate.ejerciciofin === "0") {
        //     changeloading("Favor de agregar el ejercicio fin", true);
        //     return;
        //   } else if (Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)) {
        //     changeloading("El ejercicio de inicio debe ser menor o igual al ejercicio final",true);
        //     return;
        //   }
        //   if (boxstate.periodofin === "0") {
        //     changeloading("Favor de indicar el periodo final", true);
        //     return;
        //   } else if (
        //     Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
        //     Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
        //   ) {
        //     changeloading(
        //       "El periodo de inicio no puede ser mayor a l periodo fin",
        //       true
        //     );
        //     return;
        //   }

        const fechainicio = new Date(
            boxstate.ejercicioinicio,
            Number(boxstate.periodoinicio) - 1,
            "01"
        );
        const fechafin = new Date(
            boxstate.ejerciciofin,
            Number(boxstate.periodofin) - 1,
            "01"
        );
        const post = {
            fechainicio,
            fechafin,
            tituloactual: state.tituloactua,
            tituloanterior: state.tituloanterior,
        };

        request
            .post("FECostoFinanciamiento/GenerarExcel", post)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = "AA";
                downloadLink.download = fileName;
                downloadLink.click();
                //   stratloading(false);
            })
            .catch((err) => {
                //   changeloading(JSON.stringify(err), false);
            });
    };

    const GetFechaActual = () => {
        if (boxstate.ejercicioinicio === boxstate.ejerciciofin) {
            if (boxstate.periodoinicio == boxstate.periodofin) {
                return `${GetMonthNameByNumber(boxstate.periodoinicio)} ${boxstate.ejercicioinicio
                    }`;
            } else {
                return `DE ${GetMonthNameByNumber(
                    boxstate.periodoinicio
                )} A ${GetMonthNameByNumber(boxstate.periodofin)} ${boxstate.ejercicioinicio
                    }`;
            }
        } else {
            return `${GetMonthNameByNumber(boxstate.periodoinicio)} ${boxstate.ejercicioinicio
                } A  ${GetMonthNameByNumber(boxstate.periodofin)} ${boxstate.ejerciciofin
                }`;
        }
    };
    const GetFechaActualAnterior = () => {
        if (boxstate.ejercicioinicio === boxstate.ejerciciofin) {
            if (boxstate.periodoinicio == boxstate.periodofin) {
                return `${GetMonthNameByNumber(boxstate.periodoinicio)} ${boxstate.ejercicioinicio - 1
                    }`;
            } else {
                return `DE ${GetMonthNameByNumber(
                    boxstate.periodoinicio
                )} A ${GetMonthNameByNumber(boxstate.periodofin)} ${boxstate.ejercicioinicio - 1
                    }`;
            }
        } else {
            const diferenciayear =
                boxstate.ejerciciofin - boxstate.ejercicioinicio + 1;
            return `${GetMonthNameByNumber(boxstate.periodoinicio)} ${boxstate.ejercicioinicio - diferenciayear
                } A  ${GetMonthNameByNumber(boxstate.periodofin)} ${boxstate.ejerciciofin - diferenciayear
                }`;
        }
    };
    return (
        <PlantillaScreen
            titulo={titulo}
            className={"costo-financiamiento-main-screen"}
            className_main={1}
        >
            <LoaderScreen loader={loader} />
            <div className="costo-financiemiento-contenedor-filtros">
                <div className='costo-financiamiento-regresar'
                    onClick={() => onHome()}
                >
                    <ArrowBackIcon /> Regresar
                </div>

                <BoxFiltros2
                    boxState={boxstate}
                    onBoxChange={setBoxState}
                    BoxClick={handdleBoxClick}
                    // sucursales={permisos}
                    titulo_filtro={'FILTRO'}
                    // titulo="ANALISIS DEL COSTO INTEGRAL DE FINANCIAMIENTO Y OTROS PRODUCTOS"
                    // subtitulo={state.subtitulo.toUpperCase()}
                    mostraradr={false}
                    mostrardepartamento={false}
                    mostrarsucursal={false}
                >
                </BoxFiltros2>

                <div className="buttons">
                    <button className="excel" onClick={() => GenerarExcel()}>
                        Excel
                    </button>
                </div>
            </div>
            {state.data != undefined &&
                state.data != null &&
                state.data.length === 0 ? (
                <div></div>
            ) : (
                <div className="camparativa-costo-financiamiento-container">
                    <div
                        id="comparativa-costo-financiamiento"
                        className="scroll-4"
                        style={{ marginRight: 10 }}
                    >
                        <table
                            className="table-informacion-costo-financiamiento"
                            cellSpacing={0}
                            id="tabla-sticky"
                        >
                            <thead>
                                <tr
                                    style={{
                                        textTransform: "uppercase",
                                        fontSize: "13px",
                                    }}
                                >
                                    <th className="bl sticky-col-h-30"> Concepto</th>
                                    <th colSpan={2} className="bl sticky-col-h-30">
                                        <div>{state.tituloactua}</div>
                                    </th>
                                    <th colSpan={2} className="bl sticky-col-h-30">
                                        <div>{state.tituloanterior}</div>
                                    </th>
                                    <th colSpan={2} className="bl sticky-col-h-30">
                                        <div>DESVIACION</div>
                                    </th>
                                </tr>
                                <tr>
                                    <th
                                        className="bl sticky-col-h-1"
                                        style={{ minWidth: "150px" }}
                                    ></th>
                                    <th className="bl sticky-col-h-1" style={{ minWidth: "80px" }}>
                                        Importe
                                    </th>
                                    <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                                        <div>%</div>
                                    </th>
                                    <th className="sticky-col-h-1 bl" style={{ minWidth: "80px" }}>
                                        <div>Importe</div>
                                    </th>
                                    <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                                        <div>%</div>
                                    </th>
                                    <th className="sticky-col-h-1 bl" style={{ minWidth: "80px" }}>
                                        <div>Importe</div>
                                    </th>
                                    <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                                        <div>%</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.map((item) => (
                                    <>
                                        <tr>
                                            <td className="bl br depto-title" colSpan={13}>
                                                {item.grupo}
                                            </td>
                                        </tr>
                                        {item.data.map((obj) => (
                                            <tr>
                                                <td className={`bl ${obj.clase}`}>{obj.concepto}</td>
                                                <td className={`bl ta-right ${obj.clase}`}>
                                                    {FormatMoney(obj.real)}
                                                </td>
                                                <td className={`ta-right pr-5 ${obj.clase}`}>
                                                    {obj.real === 0 || item.real === 0
                                                        ? 0
                                                        : FormatMoney((obj.real / item.real) * 100)}{" "}
                                                    %
                                                </td>
                                                <td className={`bl ta-right ${obj.clase}`}>
                                                    {FormatMoney(obj.anterior)}
                                                </td>
                                                <td className={`ta-right pr-5 ${obj.clase}`}>
                                                    {obj.real === 0 || item.anterior === 0
                                                        ? 0
                                                        : FormatMoney(
                                                            (obj.anterior / item.anterior) * 100
                                                        )}{" "}
                                                    %
                                                </td>
                                                <td className={`bl ta-right ${obj.clase}`}>
                                                    {FormatMoney(obj.anteriordiferencia)}
                                                </td>
                                                <td className={`ta-right pr-5 ${obj.clase}`}>
                                                    {FormatMoney(obj.porcentajeanterior)} %
                                                </td>
                                            </tr>
                                        ))}
                                        <tr
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <td className="bl ta-right pr-5">TOTAL</td>
                                            <td className="bl ta-right pr-5">
                                                {FormatMoney(item.real)}
                                            </td>
                                            <td className=" ta-right pr-5">100 %</td>
                                            <td className="bl ta-right pr-5">
                                                {FormatMoney(item.anterior)}
                                            </td>
                                            <td className=" ta-right pr-5">100 %</td>
                                            <td className="bl ta-right pr-5">
                                                {FormatMoney(item.real - item.anterior)}
                                            </td>
                                            <td className=" ta-right pr-5">
                                                {item.real - item.anterior === 0 || item.anterior === 0
                                                    ? 0
                                                    : FormatMoney(
                                                        ((item.real - item.anterior) / item.real) * 100
                                                    )}{" "}
                                                %
                                            </td>
                                        </tr>
                                        <tr className="separator">
                                            <td colSpan={13}></td>
                                        </tr>
                                    </>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </PlantillaScreen >

    );
};
